import { Component, OnInit } from '@angular/core';
import { BaseComponent, HeaderComponent, SideNavComponent } from '@lib/components';
import { ScrollService } from '@lib/services/scroll.service';
import { Router, NavigationEnd, RouterModule, ActivatedRoute } from '@angular/router';
import { AngularMaterialModule } from 'src/app/material.module';
import { filter, map, Observable, startWith } from 'rxjs';

@Component({
    standalone: true,
    imports: [RouterModule, AngularMaterialModule, SideNavComponent, HeaderComponent],
    selector: 'app-home',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent extends BaseComponent implements OnInit {
    protected isWelcomeScreen = false;
    protected isCollapseNav = false;
    protected drawerRouteClass: string = '';
    noDrawerPadding$: Observable<boolean>;

    constructor(private readonly scrollService: ScrollService, protected readonly router: Router, private ar: ActivatedRoute) {
        super();
        this.setWelcomeScreen();
        this.noDrawerPadding$ = this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            startWith(null),
            map(() => {
              let route: ActivatedRoute = this.ar;
              while (route.firstChild) route = route.firstChild;
              return !!route.snapshot.data?.['noDrawerPadding'];
            })
          );
        
    }

    ngOnInit(): void {}

    protected matDrawerContentScroll(event: Event): void {
        const matDrawerContent: HTMLElement = event.target as HTMLElement;
        const targetScrollBottom: number = matDrawerContent.scrollTop + matDrawerContent.clientHeight + 50; // Adjust scroll trigger threshold
        if (targetScrollBottom >= matDrawerContent.scrollHeight) this.scrollService.bottomReached();
    }

    private setWelcomeScreen(): void {
        // Check the current URL on initialization
        this.isWelcomeScreen = this.router.url === '/#/' || this.router.url === '/';

        this.addSubscription(
            this.router.events.subscribe((event): void => {
                if (event instanceof NavigationEnd) {
                    // Use event.urlAfterRedirects for accurate URL comparison
                    this.isWelcomeScreen = event.urlAfterRedirects === '/#/' || event.urlAfterRedirects === '/';
                }
            }),
        );
    }
    onCollapseStatusChange(collapseStatus: boolean) {
        this.isCollapseNav = collapseStatus;
    }
}
